import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import './Popup1.css';

function Popup1({ isDisplayShowMore = true }) {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    
    // Check localStorage for previous popup trigger
    const [hasTriggered, setHasTriggered] = useState(() => {
        return localStorage.getItem('popupTriggered') === 'true';
    });

    useEffect(() => {
        // Function to handle scroll events
        const handleScroll = () => {
            if (!hasTriggered && isDisplayShowMore) {
                // Calculate scroll percentage
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const scrollHeight = document.documentElement.scrollHeight;
                const clientHeight = document.documentElement.clientHeight;
                const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
                
                // If scrolled more than 50% and not already triggered
                if (scrollPercentage >= 50) {
                    setModalIsOpen(true);
                    setHasTriggered(true);
                    
                    // Save to localStorage to persist between tab changes
                    localStorage.setItem('popupTriggered', 'true');
                    
                    // Remove scroll listener after triggering
                    window.removeEventListener('scroll', handleScroll);
                }
            }
        };

        // Add scroll event listener if popup hasn't been triggered yet
        if (isDisplayShowMore && !hasTriggered) {
            window.addEventListener('scroll', handleScroll);
        }

        // Close the modal if isDisplayShowMore changes to false
        if (!isDisplayShowMore) {
            setModalIsOpen(false);
        }
        
        // Cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isDisplayShowMore, hasTriggered]);

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleConsultationClick = () => {
        window.open('https://calendar.app.google/GnLJrRP1KSbnNab86', '_blank');
    };

    // Use different image for mobile (simple width check)
    const isMobile = window.innerWidth < 768;
    const backgroundImage = isMobile
        ? 'url(/img/mobile-version.png)'
        : 'url(/img/consultation.png)';

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Schedule Meeting Modal"
            className="custom-modal"
            overlayClassName="custom-modal-overlay"
            style={{
                content: {
                    backgroundImage: backgroundImage
                }
            }}
        >
            <FontAwesomeIcon
                icon={faClose}
                onClick={closeModal}
                fontSize={"1.8rem"}
                className="modal-close-icon"
            />

            <div className="modal-left">
                <h2 className="modal-title">
                    Not Happy With Your<br />
                    Website <span className="highlight">Speed & Performance?</span>
                </h2>

                <button onClick={handleConsultationClick} className="consultation-button">
                    Get Free Expert Consultation
                </button>

                <p className="subtext">100% Free Service. No Obligation.</p>

                <h3 className="included-title">------------ What's included ------------</h3>

                <div className="included-list">
                    <div>✔ Site analysis</div>
                    <div>✔ Actionable solutions</div>
                    <div>✔ Strategy planning</div>
                    <div>✔ Optimization Techniques</div>
                </div>
            </div>

            <div className="modal-right" />
        </Modal>
    );
}

export default Popup1;
